import api from './api';

export default class MesesCompetenciasService {
  constructor() {
    throw 'Não é possível instanciar MesesCompetenciasService';
  }

  static async obtemPorEventoPorAno(evento, anoAtual) {
    const endpoint = mergeEndpoint();
    const params = { 'evento.tipo': evento, ano: anoAtual };
    return await api.get(endpoint, { params });
  }

  static async obtemPorEventoPorData(idMeCompetencia, evento, dataAtual) {
    const endpoint = `meses-competencias/dataAtual/${idMeCompetencia}/${evento}/${dataAtual}`;
    return await api.get(endpoint);
  }

  static async obtemPorId(idMeCompetencia) {
    const endpoint = `${mergeEndpoint()}/${idMeCompetencia}`;
    return await api.get(endpoint);
  }

  static async listaPorEvento(evento) {
    const endpoint = mergeEndpoint();
    const params = { 'evento.tipo': evento };
    return await api.get(endpoint, { params });
  }
}


const mergeEndpoint = () => {
  return `meses-competencias`;
};



// WEBPACK FOOTER //
// ./src/services/mesesCompetenciasService.js